import React, { useEffect, useState } from "react";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import Divider from "@mui/joy/Divider";
import Link from "@mui/joy/Link";
import Input from "@mui/joy/Input";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import ModalClose from "@mui/joy/ModalClose";
import Sheet from "@mui/joy/Sheet";
import Typography from "@mui/joy/Typography";
import CreateRoundedIcon from "@mui/icons-material/CreateRounded";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import SearchIcon from "@mui/icons-material/Search";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DeleteForever from "@mui/icons-material/DeleteForever";
import AddIcon from "@mui/icons-material/Add";
import { useApi } from "../../Auth/api/ApiContext";
import { useAuth } from "../../Auth/utils/useAuth";
import { CreateUserFormElement, CompanyDto } from "../../types";
import { IconButton, Option, Select, Table, Tooltip } from "@mui/joy";
import { DeleteModalBox, EditFormModal } from "../globalCards/ModalBox";
import { LoaderBox, NotfoundBox } from "../globalCards/LoaderBox";

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

type Order = "asc" | "desc";

function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string }
) => number {
  return order === "asc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(
  array: readonly T[],
  comparator: (a: T, b: T) => number
) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export default function VendorCard() {
  const {
    useAddVendorMutation,
    useVendorViewListMutation,
    useUpdateVendorMutation,
    useDeleteVendorMutation,
    error,
  } = useApi();
  const [visibleColumns] = useState([
    {
      checked: true,
      width: 140,
      name: "Vendor Name",
    },
    {
      checked: true,
      width: 140,
      name: "Address",
    },
    {
      checked: true,
      width: 140,
      name: "City",
    },
    {
      checked: true,
      width: 140,
      name: "Country",
    },
    {
      checked: true,
      width: 140,
      name: "TRN No.",
    },
  ]);
  const [rows, setRows] = useState<CompanyDto[]>([]);
  const [order, setOrder] = useState<Order>("desc");
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("Create");
  const [addCompanyShow, setAddCompanyShow] = useState(false);
  const { showToast } = useAuth();
  const [companyId, setCompanyId] = useState();
  const [companyName, setCompanyName] = useState("");
  const [trnNo, setTrnNo] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("UAE");
  const [address, setAddress] = useState("");
  const [deleteModal, setDeleteModal] = React.useState<boolean>(false);
  const [userId, setUserId] = useState<number>(0);

  useEffect(() => {
    if (useVendorViewListMutation) {
      useVendorViewListMutation.mutate();
    }
  }, []);

  useEffect(() => {
    if (useVendorViewListMutation.data) {
      setRows(useVendorViewListMutation.data);
    }

    if (useAddVendorMutation.data) {
      showToast("Vendor Create successfully", "success");
      useAddVendorMutation.reset();
      useVendorViewListMutation.mutate();
      setAddCompanyShow(false);
    }

    if (useUpdateVendorMutation.data) {
      showToast("Vendor updated successfully", "success");
      useUpdateVendorMutation.reset();
      useVendorViewListMutation.mutate();
      setAddCompanyShow(false);
    }
    if (useDeleteVendorMutation.data) {
      useDeleteVendorMutation.reset();
      setDeleteModal(false);
      showToast(`Vendor ${userId} deleted successfully`, "success");
      useVendorViewListMutation.mutate();
    }
    if (error) {
      const errorMsg = error?.includes("Foreign key")
        ? "You can not delete this customer"
        : error;
      showToast(errorMsg, "danger");
    }
  }, [
    useVendorViewListMutation,
    useAddVendorMutation.data,
    useUpdateVendorMutation.data,
    useDeleteVendorMutation.data,
    error,
  ]);

  const handleSaveCompanyName = (
    event: React.FormEvent<CreateUserFormElement>
  ) => {
    event.preventDefault();
    const formElements = event.currentTarget.elements;
    if (
      (formElements.companyName.value === "",
      formElements.address.value === "",
      city === "",
      formElements.trnNo.value === "")
    ) {
      showToast("Please fill all the fields.", "warning");
    } else {
      const newData: { [key: string]: any } = {};
      if (formElements.companyName.value !== companyName) {
        newData.companyName = formElements.companyName.value;
      }
      if (formElements.address.value !== address) {
        newData.address = formElements.address.value;
      }
      if (formElements.country.value !== country) {
        newData.country = formElements.country.value;
      }
      if (formElements.trnNo.value !== trnNo) {
        newData.trn = formElements.trnNo.value;
      }
      if (city !== "") {
        newData.city = city;
      }

      const createCustomer = {
        name: formElements.companyName.value,
        address: formElements.address.value,
        city: city,
        country: formElements.country.value,
        trn: formElements.trnNo.value,
      };
      title === "Create"
        ? useAddVendorMutation.mutate(createCustomer)
        : Object.keys(newData).length > 0 &&
          useUpdateVendorMutation.mutate({
            id: companyId,
            newData,
          });
    }
  };

  const handleAddCompanyBtn = () => {
    setTitle("Create");
    setCompanyName("");
    setAddress("");
    setCity("");
    setCountry("UAE");
    setTrnNo("");
    setAddCompanyShow(true);
  };

  const handleDeleteCustomer = (id: number) => {
    setUserId(id);
    setDeleteModal(true);
  };
  const handleDeleteConfirmUser = () => {
    if (userId) {
      useDeleteVendorMutation.mutate(userId);
    }
  };

  const renderFilters = () => (
    <React.Fragment>
      {/* ----------------Add Vendor-------------- */}
      <Button sx={{ height: "20px" }} onClick={handleAddCompanyBtn}>
        <AddIcon />
        Add New Vendor
      </Button>
    </React.Fragment>
  );

  const handleCellCopy = (content: string | number) => {
    navigator.clipboard
      .writeText(String(content))
      .then(() => {
        showToast("Copied to clipboard!", "success");
      })
      .catch(() => {
        showToast("Failed to copy!", "danger");
      });
  };

  const renderCellContent = (content: string | number, maxWidth: string) => (
    <Tooltip title={content} placement="top">
      <Typography>
        <span
          style={{
            maxWidth,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "block",
            cursor: "copy",
          }}
          onClick={() => handleCellCopy(content)}
        >
          {content}
        </span>
      </Typography>
    </Tooltip>
  );

  const handleEditBtn = (usrData: any) => {
    setAddCompanyShow(true);
    setTitle("Edit");
    setCompanyId(usrData.id);
    setCompanyName(usrData.name);
    setAddress(usrData.address);
    setCity(usrData.city);
    setCountry(usrData.country);
    setTrnNo(usrData.trn);
  };

  return (
    <React.Fragment>
      <Sheet
        className="SearchAndFilters-mobile"
        sx={{
          display: { xs: "flex", sm: "none" },
          my: 1,
          gap: 1,
        }}
      >
        <Input
          size="sm"
          placeholder="Search"
          startDecorator={<SearchIcon />}
          sx={{ flexGrow: 1 }}
        />
        <IconButton
          size="sm"
          variant="outlined"
          color="neutral"
          onClick={() => setOpen(true)}
        >
          <FilterAltIcon />
        </IconButton>
        <Modal open={open} onClose={() => setOpen(false)}>
          <ModalDialog aria-labelledby="filter-modal" layout="fullscreen">
            <ModalClose />
            <Typography id="filter-modal" level="h2">
              Filters
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Sheet sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {renderFilters()}
              <Button color="primary" onClick={() => setOpen(false)}>
                Submit
              </Button>
            </Sheet>
          </ModalDialog>
        </Modal>
      </Sheet>
      <Box
        className="SearchAndFilters-tabletUp"
        sx={{
          borderRadius: "sm",
          py: 2,
          display: { xs: "none", sm: "flex" },
          marginBottom: "6px",
          alignItems: "flex-end",
          alignSelf: "flex-end",
          flexWrap: "wrap",
          gap: 1.5,
          "& > *": {
            minWidth: { xs: "120px", md: "160px" },
          },
        }}
      >
        {/* ------------search------------ */}
        {renderFilters()}
      </Box>
      <Sheet
        className="OrderTableContainer"
        variant="outlined"
        sx={{
          display: { xs: "initial", sm: "initial" },
          width: "100%",
          borderRadius: "sm",
          flexShrink: 1,
          overflow: "auto",
          minHeight: 0,
        }}
      >
        <Table
          aria-labelledby="tableTitle"
          stickyHeader
          hoverRow
          sx={{
            "--TableCell-headBackground":
              "var(--joy-palette-background-level1)",
            "--Table-headerUnderlineThickness": "1px",
            "--TableRow-hoverBackground":
              "var(--joy-palette-background-level1)",
            "--TableCell-paddingY": "4px",
            "--TableCell-paddingX": "8px",
          }}
        >
          <thead>
            <tr>
              {visibleColumns?.map((item, index) => (
                <th
                  key={index}
                  onClick={() => setOrder(order === "asc" ? "desc" : "asc")}
                  style={{
                    display: `${item.checked ? "table-cell" : "block"}`,
                    width: item.width,
                    padding: "12px 6px",
                  }}
                >
                  <Link
                    underline="none"
                    color="primary"
                    component="button"
                    fontWeight="lg"
                    endDecorator={<ArrowDropDownIcon />}
                    sx={{
                      "& svg": {
                        transition: "0.2s",
                        transform:
                          order === "asc" ? "rotate(180deg)" : "rotate(0deg)",
                      },
                    }}
                  >
                    {item.name}
                  </Link>
                </th>
              ))}
              <th style={{ width: 140, padding: "12px 6px", color: "#0b6bcb" }}>
                Edit
              </th>
              <th style={{ width: 80, padding: "12px 6px", color: "#0b6bcb" }}>
                Delete
              </th>
            </tr>
          </thead>
          <tbody>
            {useVendorViewListMutation?.isLoading ? (
              <LoaderBox message="Loading" />
            ) : useVendorViewListMutation?.data?.length === 0 ? (
              <NotfoundBox />
            ) : (
              stableSort(rows, getComparator(order, "id")).map((row, index) => (
                <tr key={index}>
                  <td>
                    <Typography level="body-xs">
                      {renderCellContent(row?.name, "140")}
                    </Typography>
                  </td>
                  <td>
                    <Typography level="body-xs">
                      {renderCellContent(row?.address, "140")}
                    </Typography>
                  </td>
                  <td>
                    <Typography level="body-xs">
                      {renderCellContent(row.city, "140")}
                    </Typography>
                  </td>
                  <td>
                    <Typography level="body-xs">
                      {renderCellContent(row?.country, "140")}
                    </Typography>
                  </td>
                  <td>
                    <Typography level="body-xs">
                      {renderCellContent(row?.trn, "140")}
                    </Typography>
                  </td>
                  <td>
                    <Box
                      sx={{
                        display: "flex",
                        marginLeft: "5px",
                        alignItems: "center",
                      }}
                    >
                      <Tooltip title="Edit" placement="top">
                        <Link level="body-xs" component="button">
                          <CreateRoundedIcon
                            sx={{
                              color: "coral",
                              fontSize: "20px",
                              borderRadius: "20px",
                              "&:hover": {
                                padding: "2px",
                                backgroundColor: "coral",
                                color: "white",
                                cursor: "pointer",
                              },
                            }}
                            onClick={() => handleEditBtn(row)}
                          />
                        </Link>
                      </Tooltip>
                    </Box>
                  </td>
                  <td>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "10px",
                      }}
                    >
                      <Tooltip title="Delete" placement="top">
                        <Link level="body-xs" component="button">
                          <DeleteForever
                            sx={{
                              color: "red",
                              fontSize: "20px",
                              borderRadius: "20px",
                              "&:hover": {
                                padding: "1px",
                                backgroundColor: "red",
                                color: "white",
                                cursor: "pointer",
                              },
                            }}
                            onClick={() => handleDeleteCustomer(row.id)}
                          />
                        </Link>
                      </Tooltip>
                    </Box>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </Sheet>
      {/* ---------------Vendor--------------- */}
      <EditFormModal
        open={addCompanyShow}
        setOpen={setAddCompanyShow}
        title={title}
        companyName={companyName}
        companyNameCard={true}
        address={address}
        addressCard={true}
        city={city}
        setCity={setCity}
        cityCard={true}
        country={country}
        countryCard={true}
        nameTitle="Vendor Name"
        trnNo={trnNo}
        trnCard={true}
        onSubmit={handleSaveCompanyName}
      />
      {/* ---------------Delete User--------------  */}
      <DeleteModalBox
        open={deleteModal}
        setOpen={setDeleteModal}
        message={"Are you sure you want to delete customer?"}
        handleDeleteCnfrm={handleDeleteConfirmUser}
      />
    </React.Fragment>
  );
}
